<template>
  <div>
    <custom-separator
      text="Resultado de Consultas"
      class="my-4 custom-separator-line"
    />
    <template v-if="results.length">
      <SearchResultItem
        ref="resultItems"
        v-for="(item, i) in results"
        :key="i"
        :item-result="item"
        class="mt-3"
        @enter="onEnter"
        @goToHistory="goToHistory"
        @goToObservations="goToObservations"
        @goToTransferManagement="goToTransferManagement"
        @goToTransferHistory="goToTransferHistory"
        @change-status-to-new="resetTapRequestStatusToNew"
        @change-status-to-central-level-recommended="
          onChangeCreateTapRequestCopyToCentralLevelRecommendedHandler
        "
        @status-has-changed="$emit('status-has-changed')"
        @on-amendment-success="$emit('on-amendment-success')"
        @change-status-to-central-level-process="
          $emit('change-status-to-central-level-process')
        "
        @change-status-to-amend-process="onChangeToAmendProcessHandler"
        @return-status="returnStatus"
        @show-amendment-history="goToAmendmentHistory"
      />
      <Pagination
        v-if="pagination.pageCount > 1"
        :data="pagination"
        :page-size="pagination.pageSize"
        @pagination-go-page="setCurrentPage"
      />
    </template>
    <template v-else>
      <CustomResultNotFound text="No hay información disponible." />
    </template>
  </div>
</template>

<script>
import CustomSeparator from 'custom-separator';
import Pagination from '@/components/common/Pagination';
import CustomResultNotFound from 'custom-result-not-found';
import SearchResultItem from './_components/SearchResultItem';
import alert from '@/mixin/alert.mixin';
import {
  resetTapRequestStatusToNew,
  createTapRequestCopyToCentralLevelRecommended as _createTapRequestCopyToCentralLevelRecommended,
  changeTapRequestToAmendProcess,
  returnToPreviousStatus,
} from '../../_api';
import { createNamespacedHelpers } from 'vuex';
import { tapRequestStatusesEnum } from '@/components/pei/ubication-tech-assistance/_types';

const { mapState, mapMutations } = createNamespacedHelpers(
  'ubication-tech-assistance-mngmt'
);

export default {
  name: 'SearchResult',
  mixins: [alert],
  components: {
    CustomSeparator,
    SearchResultItem,
    Pagination,
    CustomResultNotFound,
  },
  computed: {
    ...mapState(['results', 'pagination']),
  },
  methods: {
    ...mapMutations(['setCurrentPage']),
    async returnStatus(item) {
      const previousStatusName = item?.returnStatus?.statusName;
      const confirm = await this.ShowCancelModal(
        'Confirmación',
        ` ¿Está seguro que desea regresar al estatus ${previousStatusName}?`,
        'SÍ­',
        'No'
      );
      if (confirm) {
        const { data: response } = await returnToPreviousStatus(item.id).catch(
          (error) => {
            this.ShowToast('Error', error.response.data.message, 'error');
          }
        );
        item.status = {
          color: response.color,
          id: response.statusId,
          text: response.statusName,
        };

        this.ShowToast(
          '',
          'El estatus ha sido actualizado exitosamente.',
          'success'
        );
        this.$emit('status-returned');
      }
    },
    async resetTapRequestStatusToNew({ id }) {
      const confirm = await this.ShowCancelModal(
        'Confirmación',
        ' ¿Está seguro que desea regresar el estatus de Sometido a Nuevo? ',
        'SÍ­',
        'No'
      );
      if (!confirm) {
        return;
      }
      const reset = await resetTapRequestStatusToNew(id);
      if (reset) {
        this.ShowToast('', 'El estatus fue cambiado exitosamente.', 'success');
        this.$emit('status-has-changed');
      }
    },
    onEnter(item) {
      this.$router.push({
        name: 'uta-management',
        params: { tapRequestId: item.id },
      });
    },
    goToObservations(item) {
      this.$router.push({
        name: 'uta-observations',
        params: { tapRequestId: item.id, studentSIE: item.student.sie },
        query: { from: 'search' },
      });
    },
    goToHistory(item) {
      this.$router.push({
        name: 'uta-history',
        params: { tapRequestId: item.id, studentSIE: item.student.sie },
      });
    },
    goToTransferManagement({ id, academicYearId, assignedData, status }) {
      if (id) {
        this.$router.push({
          name: 'transfermanagement',
          params: {
            id,
            academicYearId,
            companyId: assignedData?.assignedProvider?.id,
            statusId: status.id,
          },
        });
      }
    },
    goToTransferHistory({ id, academicYearId, assignedData }) {
      if (id) {
        this.$router.push({
          name: 'transferhistory',
          params: {
            id,
            academicYearId,
            companyId: assignedData?.assignedProvider?.id,
          },
        });
      }
    },
    goToAmendmentHistory(item) {
      this.$router.push({
        name: 'amendmenthistory',
        params: { tapRequestId: item.id, studentSIE: item.student.sie },
      });
    },
    async onChangeCreateTapRequestCopyToCentralLevelRecommendedHandler({ id }) {
      const confirm = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea cambiar el estatus de No Vigente: Baja a Recomendado a Nivel Central?',
        'SÍ­',
        'No'
      );
      if (confirm) {
        const result = (
          await _createTapRequestCopyToCentralLevelRecommended(id)
        ).data;
        if (result) {
          this.ShowToast(
            '',
            'El estatus ha sido cambiado exitosamente.',
            'success'
          );
          this.$emit('status-has-changed');
        }
      }
    },
    async onChangeToAmendProcessHandler({ id }) {
      const confirm = await this.ShowCancelModal(
        'Confirmación',
        ' ¿Está seguro que desea cambiar el estatus de Enmendado a Proceso de Enmienda?',
        'SÍ­',
        'No'
      );

      if (confirm) {
        const amendProcessStatus = {
          statusId: tapRequestStatusesEnum['Proceso de Enmienda'],
        };

        const { data } = await changeTapRequestToAmendProcess(
          id,
          amendProcessStatus
        );

        if (data) {
          this.ShowToast(
            '',
            'El estatus ha sido cambiado exitosamente.',
            'success'
          );
          this.$emit('status-has-changed');
        }
      }
    },
  },
};
</script>
